export const DashboardRouting = {
  path: "/dashboard",
  name: "dashboard",
  // component: () => import("@/views/dashboard/welcome/index.vue"),
  component: () => import("@/views/dashboard/welcome/welcome2/index.vue"),
  meta: { title: "工作台", icon: "dashboard" },
};
//资讯
export const InformationRouting = {
  path: "/informationIndex",
  name: "informationIndex",
  component: () => import("@/views/dashboard/welcome/index.vue"),
  meta: { title: "资讯", icon: "dashboard" },
};

export const PosterRouting = {
  path: "/poster",
  name: "poster",
  hidden: true,
  component: () =>
    import(/* webpackChunkName: "dashboard-welcome" */ "@/views/dashboard/poster/index.vue"),
  meta: { title: "省钱宝", icon: "dashboard" },
};
